import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';
import { CustomListDetail } from '../types/CustomListSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface RenameCustomListParams {
    listId: string;
    name: string;
}

export const renameCustomList = createAsyncThunk<
    CustomListDetail,
    RenameCustomListParams,
    ThunkConfig<string | string[]>
>('customList/renameCustomList', async ({ listId, name }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.patch<CustomListDetail>(
            `/v1/custom-lists/${listId}`,
            { name },
        );

        return response.data;
    } catch (e) {
        return rejectWithValue(getApiErrorMessage(e));
    }
});
